<template>
  <div>
      <div style="position:relative">
          <h1 v-if="$route.query.site">Update Site</h1>
          <h1 v-else>New Site</h1>

      <div v-if="loading" class="page-loading-container">
          <b-spinner label="Loading..." ></b-spinner>
      </div>
      <div v-else>
          <div style="position:absolute;right:10px;top:0px" v-if="user.available_audits > 0">
              <b-badge variant="light" ><router-link  :to="{ name: 'AccountsPage'}">{{user.available_audits}} Tests Remaining</router-link></b-badge>
          </div>
          <b-alert show variant="info" v-if="user.websites_subscription.websites_plan.name === 'free'">
              You are on the <b>Free</b> plan.<br>
              <small>To test more pages you can upgrade your account.</small>
              <p>
              </p>
              <demo-notice button="Change Plan" :angleRight="false" ></demo-notice>
          </b-alert>
    <b-row>
      <b-col xs="12" md="12">
          <b-alert show variant="danger" v-if="error">{{error}}</b-alert>
        <Widget>
          <b-form @submit.prevent="submit">

              <b-row>

              <b-col lg="8">

                  <label for="url">URL: <i data-toggle="tooltip" data-placement="top" data-html="true" v-b-tooltip.hover="`This can be the homepage (https://example.com) or any path (https://example.com/blog).`" class="fa fa-info-circle" style="color:gray;font-size:14px"></i></label>
                      <b-input
                              id="url"
                              name="url"
                              v-model="form.url"
                              type="url"
                              required
                              :readonly="!!$route.query.site"
                              placeholder="https://example.com"
                      ></b-input>

                  <label for="maxPages" class="mt-2">Max Pages:</label>
                  <b-select id="maxPages" v-model="maxPages" :options="crawlSizeOptions"></b-select>
                  <div class="mb-4" :class="{warning_label: requiredAudits > user.available_audits}"><small>{{pageCountDescription()}}</small></div>

                  <div v-if="requiredAudits > user.available_audits" type="submit" variant="info">
                      <demo-notice button="Change Plan"></demo-notice>
                  </div>
                  <b-button v-else type="submit" variant="primary" :disabled="submitting || form.dimensions.length > maxDevices || updateDisabled">
                      <b-spinner small v-if="submitting"></b-spinner>
                      <span v-else>
                          <span v-if="$route.query.site">Update</span>
                          <span v-else>Start Audit</span>
                      </span>
                  </b-button>
                  <span v-show="form.dimensions.length > maxDevices">&nbsp; <small style="color:orange">You can test on up to {{maxDevices}} devices per audit.</small>
                  </span>



              </b-col>
                  <b-col>
                      <label for="some-radios">Schedule <i data-toggle="tooltip" data-placement="top" data-html="true" v-b-tooltip.hover="`Automatically run the audit on a schedule.`" class="fa fa-info-circle" style="color:gray;font-size:14px"></i></label>
                      <b-form-group >
                          <b-form-radio class="pt-2" v-model="form.schedule" name="some-radios" value=""><span v-if="$route.query.site">Manual</span><span v-else>Manual</span></b-form-radio>
                          <b-form-radio class="pt-2" v-model="form.schedule" name="some-radios" value="weekly" :disabled="plan.name === 'free'"><span id="label_weekly" >Every week</span> </b-form-radio>
                          <b-tooltip target="label_weekly" noninteractive>4 Tests per month</b-tooltip>

                          <b-form-radio class="pt-2" v-model="form.schedule" name="some-radios" value="daily" :disabled="plan.name === 'free'"><span id="label_daily">Every day</span></b-form-radio>
                          <b-tooltip v-if="plan.name === 'free'"  target="label_daily" noninteractive>This option is not available in your current plan</b-tooltip>
                          <b-tooltip v-else target="label_daily" noninteractive>30 Tests per month</b-tooltip>

                      </b-form-group>
                  </b-col>
              </b-row>
              <b-row>
              <b-col>
                  <p></p>
                  <a href="javascript:void(0)"  v-b-toggle.collapse-1>Advanced Settings</a>
                      <b-collapse id="collapse-1" class="mt-2">


                          <b-form-group>
                              <b-form-checkbox
                                      id="checkbox-1"
                                      v-model="form.options.blockAds"
                                      name="checkbox-1"
                                      inline
                              >
                                  Block Ads
                              </b-form-checkbox>

                                  <b-form-checkbox
                                          id="checkbox-2"
                                          v-model="form.options.slowCrawl"
                                          name="checkbox-2"
                                          inline
                                  >
                                    Slow Crawl <i data-toggle="tooltip" data-placement="top" data-html="true" v-b-tooltip.hover="`If your site has a lot of dynamic content that is slow to load we can reduce the crawl speed to make sure everything renders as expected.`" class="fa fa-info-circle" style="color:gray;font-size:14px"></i>
                                  </b-form-checkbox>

                          </b-form-group>
                          <label>Exclude Directories <i data-toggle="tooltip" data-placement="top" data-html="true" v-b-tooltip.hover="`We will not crawl any urls that start with these directories`" class="fa fa-info-circle" style="color:gray;font-size:14px"></i></label>
                          <input-tag placeholder="Add directories separated by a comma" class="form-cocntrol" style="line-height: 14px;border-radius: 4px;" v-model="form.options.excludeDirectories" :before-adding="setTags"></input-tag>
                          <template v-if="!$route.query.site">
                  <h5 class="mt-3">Devices (up to 3)</h5>


                <b-card >
                    <b-form-group>
                        <b-form-checkbox-group id="checkbox-group-2" v-model="form.dimensions" >
                    <table class="table table-hover table-sm devices">
                        <thead>
                        <tr>
                            <th scope="col">Test On</th>
                            <th scope="col">Used By</th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Desktop</td>
                        </tr>
                        <tr>
                            <td> <b-form-checkbox size="sm" value="1366x768" disabled>1366x768</b-form-checkbox></td>
                            <td>23% of Desktop Users</td>
                        </tr>
                        <tr>
                            <td><b-form-checkbox size="sm" value="1920x1080">1920x1080</b-form-checkbox></td><td>21% of Desktop Users</td>
                        </tr>
                        <tr>
                            <td><b-form-checkbox size="sm" value="1440x900">1440x900</b-form-checkbox></td><td>7% of Desktop Users
                            <span style="float:right;font-size:9pt;color:gray" v-if="!showMore.desktop"><a href="" @click.prevent="showMore.desktop = !showMore.desktop">More <i class="fa fa-sort-desc log-dropdown"></i></a></span></td>
                        </tr>
                        <tr v-if="showMore.desktop">
                            <td><b-form-checkbox size="sm" value="1536x864">1536x864</b-form-checkbox></td><td>7% of Desktop Users</td>
                        </tr>
                        <tr v-if="showMore.desktop">
                            <td><b-form-checkbox size="sm" value="1600x900">1600x900</b-form-checkbox></td><td>5% of Desktop Users</td>
                        </tr>
                        <tr v-if="showMore.desktop">
                            <td><b-form-checkbox size="sm" value="1280x720">1280x720</b-form-checkbox></td><td>4% of Desktop Users</td>
                        </tr>
                        <tr>
                            <td>Mobile</td>
                        </tr>
                        <tr><td> <b-form-checkbox size="sm" value="360x640" disabled>360x640</b-form-checkbox></td><td>Galaxy S5-S10, Nexus 5, LG G3-G5, HTC One..</td></tr>
                        <tr><td> <b-form-checkbox size="sm" value="375x667">375x667</b-form-checkbox></td><td>iPhone 6, iPhone 7, iPhone 8, iPhone X</td></tr>
                        <tr><td> <b-form-checkbox size="sm" value="414x736">414x736</b-form-checkbox></td><td>iPhone 6+, iPhone 7+, iPhone 8+</td></tr>

                        <tr><td> <b-form-checkbox size="sm" value="320x480">320x480</b-form-checkbox></td>
                            <td>iPhone 4, iPhone 5, Galaxy S
                            <span style="float:right;font-size:9pt;color:gray" v-if="!showMore.mobile"><a href="" @click.prevent="showMore.mobile = !showMore.mobile">More <i class="fa fa-sort-desc log-dropdown"></i></a></span></td>
                        </tr>
                        <tr v-if="showMore.mobile">
                            <td> <b-form-checkbox size="sm" value="412x846">412x846</b-form-checkbox></td><td>Galaxy S8+, Galaxy S9+, Pixel XL</td>
                        </tr>
                        <tr v-if="showMore.mobile">
                            <td> <b-form-checkbox size="sm" value="393x786">393x786</b-form-checkbox></td><td>Pixel 3, Pixel 3XL</td>
                        </tr>

                        <tr>
                            <td>Tablet</td>
                        </tr>
                        <tr><td> <b-form-checkbox size="sm" value="768x1024">768x1024</b-form-checkbox></td><td>iPad3, iPad4, iPad Air, HTC Nexus 9</td></tr>
                        <tr><td> <b-form-checkbox size="sm" value="1024x1366">1024x1366</b-form-checkbox></td><td>iPad Pro, Surface Pro 3
                            <span style="float:right;font-size:9pt;color:gray" v-if="!showMore.tablet"><a href="" @click.prevent="showMore.tablet = !showMore.tablet">More <i class="fa fa-sort-desc log-dropdown"></i></a></span></td>
                        </tr>
                        <tr v-if="showMore.tablet">
                            <td> <b-form-checkbox size="sm" value="800x1280">800x1280</b-form-checkbox></td><td>Samsung Nexus 10, Galaxy Tab 3, Kindle Fire HD</td>
                        </tr>
                        <tr v-if="showMore.tablet">
                            <td> <b-form-checkbox size="sm" value="600x1024">600x1024</b-form-checkbox></td><td>Samsung Galaxy Tab 2, LG G Pad 8.3, Kindle Fire</td>
                        </tr>
                        <tr v-if="showMore.tablet">
                            <td> <b-form-checkbox size="sm" value="720x1280">720x1280</b-form-checkbox></td><td>Microsoft Surface Pro, Pro 2</td>
                        </tr>
                        </tbody>
                    </table>

                        </b-form-checkbox-group>
                        <small>{{form.dimensions.length }} selected devices</small>

                    </b-form-group>

                </b-card>
                          </template>
                      </b-collapse>
              </b-col>
            </b-row>

          </b-form>
        </Widget>
      </b-col>
    </b-row>
      </div>
      </div>
  </div>
</template>

<script>
import InputTag from 'vue-input-tag'
import Widget from "@/components/Widget/Widget";
import DemoNotice from "@/components/DemoNotice/DemoNotice";

import axios from "axios";
import gql from "graphql-tag";
import { mapState } from 'vuex';
export default {
  name: "New",
  components: { Widget, InputTag, DemoNotice },
  computed: {
    ...mapState({ user: 'user'}),
    routeName() {
      return this.$route.name;
    },
    updateDisabled(){
      if (this.$route.query.site && !this.editSite){
        return true;
      }
      return false;
    },
    requiredAudits(){
      let frequency = {
        onceOff: 1,
        monthly: 1,
        weekly: 4,
        daily: 30,
        hourly: 30 * 24,
      };
      if (this.form.schedule){
        return this.maxPages * frequency[this.form.schedule]
      }
      else{
        return this.maxPages
      }
    }
  },
  data() {
    return {
      loading: true,
      tags: ['a'],
      completed: false,
      error: "",
      subscription: null,
      editSite: null,
      maxDevices: 3,
      showMore: {
        "desktop": false,
        "mobile": false,
        "tablet": false,
      },
      toastOptions: {
        theme: 'dark',
        position: 'bottomLeft',
      },
      submitting: false,
      minPages: 100,
      plan:{
      },
      availableAt: 0,
      maxPages: 50,
      crawlSizeOptions: [],
      form: {}
    };
  },
  apollo: {
    $subscribe: {
      websites_website: {
        query() {
          return gql`subscription {
                  websites_subscription {
                    state
                    pages_per_audit
                    websites_plan{
                      name
                      display_name
                      options
                    }
                  }
          }`
        },
        skip () {
          return false;
        },
        result (data) {
          this.subscription = data.data.websites_subscription[0];
          if (this.subscription) {
            this.plan = this.subscription.websites_plan;
          }
          else{
            this.plan = {pages_per_audit: 500}
          }
          this.loading = false;

          this.crawlSizeOptions = [
            {text: '1 Page', value: 1},
            {text: '5 Pages', value: 5, disabled: this.subscription.pages_per_audit < 5},
            {text: '15 Pages', value: 15, disabled: this.subscription.pages_per_audit < 15},
            { text: '25 Pages', value: 25, disabled: this.subscription.pages_per_audit < 25 },
            { text: '50 Pages', value: 50, disabled: this.subscription.pages_per_audit < 50 },
            { text: '100 Pages', value: 100, disabled: this.subscription.pages_per_audit < 100 },
            { text: '250 Pages', value: 250, disabled: this.subscription.pages_per_audit < 250 },
            { text: '500 Pages', value: 500, disabled: this.subscription.pages_per_audit < 500 }
            ];

          if (this.subscription.pages_per_audit < 50){
            this.maxPages = 25;
          }
          if (this.subscription.pages_per_audit < 25){
            this.maxPages = 15;
          }
          if (this.subscription.pages_per_audit < 15){
            this.maxPages = 5;
          }
          if (this.subscription.pages_per_audit < 5){
            this.maxPages = 1;
          }
        },

      },
      edit_site: {
        query() {
          return gql`subscription {
              websites: websites_website(where: {id: {_eq: ${this.$route.query.site}}}) {
                id
                uuid
                url
                demo
                recurring
                recurring_schedule
                crawl_options
                max_crawl_pages
                uuid
              }
          }`
        },
        skip () {
          return !this.$route.query.site;
        },
        result (data) {
          this.editSite = data.data.websites[0];
          if (!this.editSite){
            this.$router.push({name: "WebsitesPage"});
            return;
          }
          this.form.url = this.editSite.url;
          this.form.schedule = this.editSite.recurring_schedule;
          this.maxPages = this.editSite.max_crawl_pages;
          let options = this.editSite.crawl_options || {};
          this.form.options.blockAds = options['block_ads'];
          this.form.options.slowCrawl = !!options['slow_down'];
          this.form.options.excludeDirectories = options['exclude_directories'] || [];

        },

      },
    }
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'New Site - PageWatch.dev',
    // all titles will be injected into this template
  },
  methods: {
    setTags(tag){
      tag = tag.trim();
      if (!tag.endsWith('/')){
        tag += '/';
      }
      if (!tag.startsWith('/')){
        tag = '/' + tag;
      }
       return tag
    },
    pageCountDescription(){
      if (this.form.schedule){
        if (this.requiredAudits === 1){
          return `${this.requiredAudits} test per month`
        }
        else{
          return `${this.requiredAudits} tests per month`
        }
      }
      else{
        if (this.requiredAudits === 1) {
          return `1 test`;
        }
        else{
          return `Up to ${this.requiredAudits} tests`;
        }

      }

    },
    updateSite() {
      this.error = '';
      this.submitting = true;

      axios
        .put(`websites/update/${this.editSite.uuid}`, {
          schedule: this.form.schedule,
          crawl_size: this.maxPages,
          options:{
            block_ads: this.form.options.blockAds,
            slow_crawl: this.form.options.slowCrawl,
            exclude_directories: this.form.options.excludeDirectories,
          },
        })
        .then(
          response => {
            this.submitting = false;
            this.$router.push({name: "WebsitesPage"});
            return true;
          },
          error => {
            this.submitting = false;
            if (error.response && error.response.data && error.response.data.message) {
              this.error = error.response.data.message;
            }
            else{
              this.error = 'There was an error adding your website, please try again.';
            }
            return false;
          }
        );
    },
    startAudit() {
      this.error = '';
      this.submitting = true;

      axios
        .post(`websites/new`, {
          url: this.form.url,
          schedule: this.form.schedule,
          options:{
            block_ads: this.form.options.blockAds,
            slow_crawl: this.form.options.slowCrawl,
            exclude_directories: this.form.options.excludeDirectories,
          },
          crawl_size: this.maxPages,
          dimensions: this.form.dimensions,
        })
        .then(
          response => {
            this.submitting = false;
            this.$root.$emit("websites-reload");
            this.$router.push({ name: "Dashboard" });
            return true;
          },
          error => {
            this.submitting = false;
            if (error.response && error.response.data && error.response.data.message) {
              this.error = error.response.data.message;
            }
            else{
              this.error = 'There was an error adding your website, please try again.';
            }
            return false;
          }
        );
    },
    submit(){
      if (this.editSite){
        this.updateSite();
      }
      else{
        this.startAudit();
      }
    },
  },
  mounted() {
    if (this.user.role !== 'user'){
      this.$router.push({ name: "Dashboard" });
    }
  },

  created() {
    this.$watch("$route",() => {
      this.form = {
        schedule: '',
        options:{
          blockAds:false,
          slowCrawl:false,
          excludeDirectories: [],
        },
        url: "",
        dimensions: ["1366x768", "360x640", "768x1024"],
      }
    }, {
      immediate: true
    });
  }
};
</script>

<style lang="scss">
    .warning_label{
        color:red;
    }
    .log-dropdown{
        position:relative;
        left:2px;
        top:-2px;
    }
    .devices{
        div{
            min-height:1rem;
        }
    }
    select option:disabled {
        color: #A9A9A9;
    }
</style>
